import { useTranslation } from 'react-i18next'

import { useInitData, useThemeMode } from '../../../hooks'
import { isThemeDark } from '../../../utils/themeMode'
import { AVATAR_HEIGHT_24 } from '../../Avatar'
import { BUTTON_HEIGHT_32 } from '../../Button'
import { PageActionsButtonAddEntity } from '../../PageActionsButtonAddEntity'
import { ButtonIconSelectControl, ButtonSelect } from '../../Select'

import { useHandleSelectAddEntityOption } from './LayoutHeaderAddEntityButton.hooks'
import { getLayoutHeaderAddEntityButtonOptions } from './LayoutHeaderAddEntityButton.utils'

import * as styles from './LayoutHeaderAddEntityButton.module.css'

function LayoutHeaderAddEntityButton({
  className = styles.LayoutHeaderAddEntityButton,
  modalHandlers,
}) {
  const { t } = useTranslation()

  const { sections } = useInitData()

  const { theme } = useThemeMode()

  const options = getLayoutHeaderAddEntityButtonOptions({
    sections,
    t,
  })

  const handleSelectItem = useHandleSelectAddEntityOption(modalHandlers)

  return options.length > 0 ? (
    <ButtonSelect
      Control={ButtonIconSelectControl}
      className={className}
      controlProps={{
        Button: PageActionsButtonAddEntity,
        buttonProps: {
          height: BUTTON_HEIGHT_32,
          tooltip: t('Header.CreateEntityBtnTooltipKey'),
        },
      }}
      dropdownFloatingConfig={{ maxWidthByRef: false }}
      listProps={{
        headerProps: {
          Search: null,
        },
        itemProps: {
          contentProps: {
            avatarProps: {
              avatarClassName: styles.icon,
              iconSize: AVATAR_HEIGHT_24,
              size: AVATAR_HEIGHT_24,
            },
            infoProps: {
              contentTextProps: {
                textProps: {
                  isSecondary: true,
                },
              },
            },
            isIconFollowingHover: isThemeDark(theme),
          },
        },
      }}
      options={options}
      onSelectItem={handleSelectItem}
    />
  ) : null
}

export default LayoutHeaderAddEntityButton
